import { CreatePatientResponseDto } from "@/data/dto/create-patient-reponse-dto";
import { UserInfoResponseDto } from "@/data/dto/user-info-response-dto";
import { CreatePatientWithGuardianPayload } from "@/data/payload/create-patient-with-guardian-payload";
import { ChangePasswordRequestPayload } from "@/data/payload/user/change-password-request-payload";
import { ResendSMSForSetupAccountRequestPayload } from "@/data/payload/user/re-send-sms-for-setup-account-request-payload";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class UserSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  //MARK:- Get User Info
  async getUserInfo(): Promise<SATResult<UserInfoResponseDto, SATError>> {
    try {
      const url = URLList.USER.GET_USER_INFO;
      const response = await this.client.get(url);
      // // 테스트를 위해 매핑 실패를 유도하는 잘못된 JSON 반환
      // const invalidData = {
      //   // fullName: response.data.fullName,
      //   hospitalCode: response.data.hospitalCode,
      //   // hospitalName: response.data.hospitalName,
      //   role: response.data.role,
      // };
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[AuthSource] :: getUserInfo :: 사용자 정보 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: getUserInfo | ", satError);
      return SATResult.failure(satError);
    }
  }

  async createPatientWithGuardian(
    payload: CreatePatientWithGuardianPayload
  ): Promise<SATResult<CreatePatientResponseDto, SATError>> {
    try {
      const response = await this.client.post(
        URLList.USER.CREATE_PATIENT_WITH_GUARDIAN,
        payload
      );
      console.log("[UserSource] :: createPatientWithGuardian :: 환자 등록 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[AuthSource] :: createPatientWithGuardian :: 환자 등록 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: createPatientWithGuardian | ", satError);
      return SATResult.failure(satError);
    }
  }

  async changePasswordWhenLogin(
    payload: ChangePasswordRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.USER.CHANGE_PASSWORD}`;
      const response = await this.client.put(url, payload);
      console.log("[UserSource] :: changePassword :: 비밀번호 변경 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[UserSource] :: changePassword :: 비밀번호 변경 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[AuthSource] :: changePassword | ", satError);
      return SATResult.failure(satError);
    }
  }

  async resendSMSForSetupAccount(
    payload: ResendSMSForSetupAccountRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.USER.RESEND_SMS_FOR_SETUP_ACCOUNT}/${payload.patientId}`;
      const response = await this.client.post(url);
      console.log("[UserSource] :: sendSMSForSetupAccount :: 계정 설정 요청 성공");
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.log("[UserSource] :: sendSMSForSetupAccount :: 계정 설정 요청 실패", error);
      const satError = errorConverter.convertError(error);
      console.log("[UserSource] :: sendSMSForSetupAccount | ", satError);
      return SATResult.failure(satError);
    }
  }
}
